import React from 'react'
import { BackArrowButton } from '@doseme/cohesive-ui'

import './index.scss'

interface IProps {
  title: string
  subtitle?: string
  testid?: string
  handleBackClick: () => void
}

const FormPageLayout: React.FC<IProps> = (props) => {
  return (
    <div className='d-flex justify-content-center'>
      <div className='form-page-layout'>
        <BackArrowButton className='back-button-offset mt-2' onClick={props.handleBackClick} />
        <div className='pr-3 mb-1'>
          <h4 className='co-h4' data-test={props.testid}>{props.title}</h4>
          {props.subtitle ? (<h6 className='co-h5' data-test='subtitle'>{props.subtitle}</h6>) : null}
        </div>
        {props.children}
      </div>
    </div>
  )
}

export {
  FormPageLayout
}
